import { Component } from '@angular/core';

@Component({
    selector: 'ukho-unexpected-error',
    standalone: true,
    templateUrl: './unexpected-error.component.html',
    styleUrls: ['./unexpected-error.component.scss']
})
export class UnexpectedErrorComponent {}
